"use client";

import { Button, Stack, Typography } from "@mui/material";
import { useSiteSearchContext } from "./SiteSearchContext";
import DOMPurify from "isomorphic-dompurify";
import React from "react";
import { Box } from "@mui/system";

export default function CategoryDetails() {
  const { targetCategory } = useSiteSearchContext();
  const [show, setShow] = React.useState(false);
  if (targetCategory?.description) {
    return (
      <Stack sx={{ mt: 1, position: "relative" }}>
        <Typography
          sx={{
            transition: "0.2s all ease",
            ...(!show && {
              maxHeight: 300,
              overflow: "hidden",
            }),
          }}
          component={"div"}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(targetCategory?.description) }}
        ></Typography>
        <Box
          sx={(theme) => ({
            width: "100%",
            transition: "0.2s all ease",
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "center",
            ...(show && {}),
            ...(!show && {
              position: "absolute",
              height: "150px",
              bottom: 0,
              left: 0,
              right: 0,
              background: `linear-gradient(to top,${theme.palette.background.default} 75%,transparent)`,
            }),
          })}
        >
          <Button
            variant={"text"}
            sx={{ borderRadius: 3 }}
            onClick={() => {
              setShow((prevState) => !prevState);
            }}
          >
            {!show ? "ببشتر" : "کمتر"}
          </Button>
        </Box>
      </Stack>
    );
  }

  return <></>;
}
